/**
 * Equalize heights
 *
 * Equalizes all sibling elements heights
 * 
 * @param {string} el - selector
 * @return {void}
 * 
 * How to use: add 'js-itbl__equalize-heights' class to parent element and add 'js-itbl__equalize-heights--elem' class to all elements you want to equalize
 */

const $ = require( 'jQuery' );

var EqualizeHeights = function(el){
    this.$el = $(el);
    this.$elements = this.$el.find('.js-itbl__equalize-heights--elem');
    this.init();
};

EqualizeHeights.prototype.init = function(){
    if(window.innerWidth > 1350){
        var heights = [];
        $(this.$elements).each((key, element) => {
            heights.push($(element).height());
        });

        var maxHeight = Math.max.apply(null, heights);
        $(this.$elements).height(maxHeight);
    }
};

$(document).ready(function(){
    $('.js-itbl__equalize-heights').each(function(){
        new EqualizeHeights(this);
    });
});

